import type { FileStatus, ProcessedFile } from '../types';

export const filterFilesByStatus = (
  files: ProcessedFile[],
  statusFilter: FileStatus | 'all',
  showDuplicatesOf?: string | null,
  getUploadStatus?: (file: File) => {
    status: string;
    progress: number;
    error?: string;
  } | null
): ProcessedFile[] => {
  let filtered = files;

  // Filter by status
  if (statusFilter !== 'all') {
    filtered = filtered.filter(file => {
      switch (statusFilter) {
        case 'ready-to-check':
          return file.processedStatus === 'ready-to-check';
        case 'duplicated':
          return file.processedStatus === 'duplicated';
        case 'allowed':
          return file.validationStatus.status === 'server-valid';
        case 'not-allowed':
          return file.validationStatus.status === 'server-invalid';
        case 'exists':
          return (
            file.validationStatus.status === 'server-valid' &&
            file.validationStatus.serverValidation?.exists
          );
        case 'pending':
        case 'uploading':
        case 'uploaded':
        case 'failed': {
          const uploadStatus = getUploadStatus?.(file.file);
          if (uploadStatus) {
            // Map upload queue statuses to our filter statuses
            const mappedStatus =
              uploadStatus.status === 'completed'
                ? 'uploaded'
                : uploadStatus.status;
            return mappedStatus === statusFilter;
          } else if (
            statusFilter === 'failed' &&
            file.validationStatus.status === 'server-invalid'
          ) {
            // Show Not Allowed files as failed in upload progress mode
            return true;
          } else if (statusFilter === 'pending') {
            // Files without upload status but valid are pending
            return (
              file.validationStatus.status === 'server-valid' &&
              (!file.validationStatus.serverValidation?.exists ||
                file.uploadStrategy === 'overwrite')
            );
          }
          return false;
        }
        default:
          return true;
      }
    });
  }

  // Filter by duplicate group
  if (showDuplicatesOf) {
    filtered = filtered.filter(file => file.file.name === showDuplicatesOf);
  }

  return filtered;
};

